import { render, staticRenderFns } from "./WorkflowJob.vue?vue&type=template&id=f45a59f6&"
import script from "./WorkflowJob.vue?vue&type=script&lang=ts&"
export * from "./WorkflowJob.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports